module.exports = __webpack_public_path__ + "img/shop-face-2x.f21c2264.png";